:host {
    display: block;
    overflow: hidden;
    --header-without-aside-height: 70px;
    --header-with-aside-height: 102px;
}

.card {
    padding: 2rem 2.5rem;
    border-radius: 0.5rem;
    width: 448px;
    box-shadow: 0 0 1rem 0.25rem rgba(81, 97, 111, 0.16);
}

#main {
    height: calc(100vh - var(--header-with-aside-height));
}

#leftBlock {
    min-height: calc(100vh - var(--header-with-aside-height));
    height: 100%;
    overflow: hidden;
    position: relative;
}

.blue-gradient {
    background: linear-gradient(to top, var(--blue), rgba(0,0,0,0) 60%);
    aspect-ratio: 475 / 564;
}

#rightBlock {
    min-height: calc(100vh - var(--header-with-aside-height));
    height: 100%;
    overflow-y: auto;
}

@media screen and (max-width: 768px) {
    #main {
        height: calc(100vh - var(--header-without-aside-height));
    }
    #leftBlock {
        min-height: calc(100vh - var(--header-without-aside-height));
    }
    #rightBlock {
        min-height: calc(100vh - var(--header-without-aside-height));
    }
}

@media screen and (max-width: 576px) {
    .card {
        box-shadow: none;
        border: none;
    }

    #rightBlock {
        padding-left: 0;
        padding-right: 0;
    }
}

